import axios from 'axios';

const state = {
    defaultPosts: [],
    boardPosts: [],
    boardColumns: [],
    submitFormVisibility: false,
    updateFormVisibility: false,
    divisions: [],
    businessLines: [],
    clientTypes: [],
    contractTypes: [],
    companyTypes: [],
    companyUsers: [],
    selectedColumn: '',
   // isoOwnershipUser: false, // for toggling ownership on and off
    filters: {
        sort: 'Date Created: Ascending',
        companyType: '',
        businessLine: '',
        contractType: '',
        clientType: '',
        search: '',
        divisions: [],
        userIsoOwnership: false,
        userIsoOwnershipManager: ''
    }
};

const getters = {
    boardPosts: state => state.boardPosts,
    divisions: state => {
        return state.divisions;
    },
    businessLines: state => {
        return state.businessLines;
    },
    clientTypes: state => {
        return state.clientTypes;
    },
    contractTypes: state => {
        return state.contractTypes;
    },
    companyTypes: state => {
        return state.companyTypes;
    },
    boardColumns: state => state.boardColumns,
    winLossPostCount: state => {
        let countArray = [];
        countArray.push(state.boardPosts[4].length);
        countArray.push(state.boardPosts[5].length);
        countArray.push(state.boardPosts[6].length);
        return countArray;
    },
    getColumnPercentages: state => {
        return state.boardColumns.map((obj) => {
            return (obj.percentage.$numberDecimal * 100).toString() + '%';
        });
    },
    summaryTableData: state => {
        return state.boardColumns;
    },
    totalAdjustedValue: state => {
        let total = 0;

        state.boardColumns.forEach(column => {
            total += (column.total.$numberDecimal * column.percentage.$numberDecimal);
        });

        return total;
    },
    totalOpportunities: state => {
        let postCount = 0;

        state.boardPosts.forEach(postColumn => {
            postCount += postColumn.length;
        });

        return postCount;
    },
    getCompanyUsers: state => {
        return state.companyUsers;
    },
    filters: state => {
        return state.filters;
    },
    selectedDivisions: state => {
        return state.filters.divisions;
    },
};

const actions = {
    getAllBoardPostData: ({commit, dispatch}) => {
        function getBoardColumns() {
            return axios.get('api/summary-board/columns');
        }

        function getBoardPosts() {
            return axios.get('api/summary-board/posts');
        }

        axios.all([getBoardColumns(), getBoardPosts()])
            .then(axios.spread((columnData, postData) => {
                let rawPosts = postData.data;
                let columns = columnData.data;
                // let posts = Array.from({length: columns.length}, () => []);
                let posts = [[],[],[],[],[],[],[]];

                rawPosts.forEach((post) => {
                    posts[post.column_index].push(post);
                });

                console.log(posts);

                columns.forEach((column, index) => {
                    let columnTotal = 0;
                    let postCount = posts[index].length;
                    //add post count key and value to column array
                    column.post_count = postCount;

                    posts[index].forEach((post) => {
                        columnTotal += post.annual_value;
                    });

                    column.total.$numberDecimal = columnTotal;
                });

                commit('setBoardColumns', columns);
                commit('setDefaultPosts', posts);
 
                // Save default posts before filtering. so that we can always filter the original posts
                dispatch('filter_isos', posts);
            }))
            .catch(error => console.log(error));
    },
    toggleSubmitFormVisibility: ({state}, payload) => {
        // Check to see if the iso column index has been set inside the payload
        if (payload !== undefined) {
            state.selectedColumn = payload;
        } else {
            state.selectedColumn = '';
        } 

        state.submitFormVisibility = !state.submitFormVisibility;
    },
    toggleUpdateFormVisibility: ({state}) => {
        state.updateFormVisibility = !state.updateFormVisibility;
    },
    getDivisions: ({commit}) => {
        axios.get('api/settings/divisions')
            .then((result) => {
                // console.log(result)
                commit('setDivisions', result.data)
            })
            .catch(error => console.log(error))
    },
    getBusinessLines: ({commit}) => {
        axios.get('api/settings/business-lines')
            .then((result) => {
                // console.log(result)
                commit('setBusinessLines', result.data)
            })
            .catch(error => console.log(error))
    },
    getClientTypes: ({commit}) => {
        axios.get('api/settings/client-types')
            .then((result) => {
                // console.log(result)
                commit('setClientTypes', result.data)
            })
            .catch(error => console.log(error))
    },
    getContractTypes: ({commit}) => {
        axios.get('api/settings/contract-types')
            .then((result) => {
                // console.log(result)
                commit('setContractTypes', result.data)
            })
            .catch(error => console.log(error))
    },
    getCompanyTypes: ({commit}) => {
        axios.get('api/settings/company-types')
            .then((result) => {
                // console.log(result)
                commit('setCompanyTypes', result.data)
            })
            .catch(error => console.log(error))
    },
    companyUsers: ({commit}) => {
        axios.get('api/users/company-users')
        .then((result) => {
            commit('setCompanyUsers', result.data);
        })
        .catch(error => console.log(error));
    },
    filter_isos: ({state, commit, rootState, dispatch}, isoData) => {
        let filters = state.filters;
        // console.log(state.defaultPosts);
        // Clone the defaultPosts object so we can make changes to the data without modifying the defaultPosts state object
        //let isos = JSON.parse(JSON.stringify(state.defaultPosts)); // issue - pulling blank array

        let isos = (isoData !== undefined) ? isoData : JSON.parse(JSON.stringify(state.defaultPosts));

        // ISO DIVISION FILTER
        for(let i = 0; i < isos.length; i++) { 
            // move isos that match the condition into the new array
            isos[i] = isos[i].filter(iso => {
                if (filters.divisions.includes(iso.division) || filters.divisions.includes('undefined') && iso.division === '') {
                    return iso;
                }
            });
        }

        // ISO AUTHOR FILTER
        if (filters.userIsoOwnership) {
            let userId = rootState.Auth.user._id; // getting user id from Auth store module
            // loop each board column
            for(let i = 0; i < isos.length; i++) {
                isos[i] = isos[i].filter(iso => {
                    if (iso.author_id === userId) {
                        return iso;
                    }
                });
            }
        }

        // ISO AUTHOR FILTER
        if (filters.userIsoOwnershipManager !== '') {
            // loop each board column
            for(let i = 0; i < isos.length; i++) {
                isos[i] = isos[i].filter(iso => {
                    if (iso.author_id === filters.userIsoOwnershipManager) {
                        return iso;
                    }
                });
            }
        }

        // ISO COMPANY TYPE FILTER 
        if (filters.companyType !== '') {
            // column loop
            for(let i = 0; i < isos.length; i++) { 
                // move isos that match the condition into the new array
                isos[i] = isos[i].filter(iso => {
                    if (iso.company_type === filters.companyType) {
                        return iso;
                    }
                });
            }
        }

        // ISO BUSINESS LINE FILTER
        if (filters.businessLine !== '') {
            // column loop
            for(let i = 0; i < isos.length; i++) { 
                // move isos that match the condition into the new array
                isos[i] = isos[i].filter(iso => {
                    if (iso.lines_of_business === filters.businessLine) {
                        return iso;
                    }
                });
            }
        }

        // ISO CLIENT TYPE FILTER
        if (filters.clientType !== '') {
            // column loop
            for(let i = 0; i < isos.length; i++) { 
                // move isos that match the condition into the new array
                isos[i] = isos[i].filter(iso => {
                    if (iso.client_type === filters.clientType) {
                        return iso;
                    }
                });
            }
        }

        // ISO CONTRACT TYPE FILTER
        if (filters.contractType !== '') {
            // column loop
            for(let i = 0; i < isos.length; i++) { 

                // move isos that match the condition into the new array
                isos[i] = isos[i].filter(iso => {
                    if (iso.contract_type === filters.contractType) {
                        return iso;
                    }
                });
            }
        }

        // ISO SORTING FILTER
        if (filters.sort !== '') {
            if (filters.sort === 'Due Date: Ascending') {
                // loop each array (column) of isos
                for (let i = 0; i < isos.length; ++i) {
                    // if there is more than one iso we can perform the sorting
                    if (isos[i].length > 1) {
                        isos[i].sort((a, b) => {
                            let dateA = parseInt(a.due_date.replace(/-/g, ''));
                            let dateB = parseInt(b.due_date.replace(/-/g, ''));

                            return dateA - dateB;
                        });
                    }
                }
            }

            if (filters.sort === 'Due Date: Descending') {
                // loop each array (column) of isos
                for (let i = 0; i < isos.length; ++i) {
                    // if there is more than one iso we can perform the sorting
                    if (isos[i].length > 1) {
                        isos[i].sort((a, b) => {
                            let dateA = parseInt(a.due_date.replace(/-/g, ''));
                            let dateB = parseInt(b.due_date.replace(/-/g, ''));

                            return dateB - dateA;
                        });
                    }
                }
            }

            if (filters.sort === 'Value: Ascending') {
                // loop each array (column) of isos
                for (let i = 0; i < isos.length; ++i) {
                    // if there is more than one iso we can perform the sorting
                    if (isos[i].length > 1) {
                        isos[i].sort((a, b) => {
                            let valueA = a.annual_value;
                            let valueB = b.annual_value;

                            return valueA - valueB;
                        });
                    }
                }
            }

            if (filters.sort === 'Value: Descending') {
                // loop each array (column) of isos
                for (let i = 0; i < isos.length; ++i) {
                    // if there is more than one iso we can perform the sorting
                    if (isos[i].length > 1) {
                        isos[i].sort((a, b) => {
                            let valueA = a.annual_value;
                            let valueB = b.annual_value;

                            return valueB - valueA;
                        });
                    }
                }
            }

            if (filters.sort === 'Date Created: Ascending') {
                // loop each array (column) of isos
                for (let i = 0; i < isos.length; ++i) {
                    // if there is more than one iso we can perform the sorting
                    if (isos[i].length > 1) {
                        isos[i].sort((a, b) => {
                            let dateA = parseInt(a.created_at);
                            let dateB = parseInt(b.created_at);

                            return dateA - dateB;
                        });
                    }
                }
            }

            if (filters.sort === 'Date Created: Descending') {
                // loop each array (column) of isos
                for (let i = 0; i < isos.length; ++i) {
                    // if there is more than one iso we can perform the sorting
                    if (isos[i].length > 1) {
                        isos[i].sort((a, b) => {
                            let dateA = parseInt(a.created_at);
                            let dateB = parseInt(b.created_at);

                            return dateB - dateA;
                        });
                    }
                }
            }

            if (filters.sort === 'Last Updated: Ascending') {
                // loop each array (column) of isos
                for (let i = 0; i < isos.length; ++i) {
                    // if there is more than one iso we can perform the sorting
                    if (isos[i].length > 1) {
                        isos[i].sort((a, b) => {
                            let dateA = parseInt(a.updated_at);
                            let dateB = parseInt(b.updated_at);

                            return dateA - dateB;
                        });
                    }
                }
            }

            if (filters.sort === 'Last Updated: Descending') {
                // loop each array (column) of isos
                for (let i = 0; i < isos.length; ++i) {
                    // if there is more than one iso we can perform the sorting
                    if (isos[i].length > 1) {
                        isos[i].sort((a, b) => {
                            let dateA = parseInt(a.updated_at);
                            let dateB = parseInt(b.updated_at);

                            return dateB - dateA;
                        });
                    }
                }
            }

            if (filters.sort === 'Company Name: A to Z') {
                // loop each array (column) of isos
                for (let i = 0; i < isos.length; ++i) {
                    // if there is more than one iso we can perform the sorting
                    if (isos[i].length > 1) {
                        isos[i].sort((a, b) => {
                            let nameA = a.company_name;
                            let nameB = b.company_name;

                            if (nameA < nameB) { return -1; }
                            if (nameA > nameB) { return 1; }
                            return 0;
                        });
                    }
                }
            }

            if (filters.sort === 'Company Name: Z to A') {
                // loop each array (column) of isos
                for (let i = 0; i < isos.length; ++i) {
                    // if there is more than one iso we can perform the sorting
                    if (isos[i].length > 1) {
                        isos[i].sort((a, b) => {
                            let nameA = a.company_name;
                            let nameB = b.company_name;

                            if (nameA < nameB) { return 1; }
                            if (nameA > nameB) { return -1; }
                            return 0;
                        });
                    }
                }
            }
        }

        // ISO SEARCH FILTER
        if (filters.search !== '') {
            for (let i = 0; i < isos.length; ++i) {
                if (isos[i].length > 0) {
                    isos[i] = isos[i].filter(iso => {
                        // console.log(iso);

                        if (iso.company_name.includes(filters.search)) {
                            return iso;
                        }
                    });
                }
            }
        }
        
        commit('setBoardPosts', isos);
        dispatch('update_column_values', isos);
    },
    default_selected_divisions({commit}) {
        axios.get('api/settings/divisions')
            .then((result) => {
                // add undefined 
                result.data.push('undefined');
                commit('set_selected_divisions', result.data)
            })
            .catch(error => console.log(error))
    },
    update_column_values: ({state, commit}) => {
        let boardPosts = state.boardPosts;
        let columns = state.boardColumns;

        columns.forEach((column, index) => {
            let columnTotal = 0;
            let postCount = boardPosts[index].length;
            //add post count key and value to column array
            column.post_count = postCount;

            boardPosts[index].forEach((post) => {
                columnTotal += post.annual_value;
            });

            column.total.$numberDecimal = columnTotal;
        });

        // console.log('hihihi');

        commit('setBoardColumns', columns);
    },
    add_iso_to_array: ({state, commit, dispatch}, newIso) => {
        // let isos = JSON.parse(JSON.stringify(state.boardPosts));
        let isos = JSON.parse(JSON.stringify(state.defaultPosts));

        let isoColumnIndex = newIso.column; 
        isos[isoColumnIndex].push(newIso);

        commit('setDefaultPosts', isos);
        dispatch('filter_isos');
    },
};

const mutations = {
    setDefaultPosts: (state, payload) => {
        state.defaultPosts = payload;
    },
    setBoardPosts: (state, payload) => {
        state.boardPosts = payload;
    },
    setBoardColumns: (state, payload) => {
        state.boardColumns = payload;
    },
    setDivisions: (state, payload) => {
        state.divisions = payload;
    },
    setBusinessLines: (state, payload) => {
        state.businessLines = payload;
    },
    setClientTypes: (state, payload) => {
        state.clientTypes = payload;
    },
    setContractTypes: (state, payload) => {
        state.contractTypes = payload;
    },
    setCompanyTypes: (state, payload) => {
        state.companyTypes = payload;
    },
    setCompanyUsers: (state, payload) => {
        state.companyUsers = payload;
    },
    update_company_type_filter: (state, value) => {
        state.filters.companyType = value;
    },
    update_filter_values: (state, payload) => {
        state.filters = payload;
    },
    set_selected_divisions: (state, payload) => {
        // console.log(payload);
        state.filters.divisions = payload;
    },
};

export default {
    state,
    getters,
    actions,
    mutations
};